import { createRequest } from "helpers/tools";

export const updateConnectionName = async (connection_id, data) => {
    return await createRequest({
        suffix: `lead/connection/${connection_id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};
